/**
 * Экран закрытого раздела.
 *
 * Раздел не прячется из меню, а честно говорит, что закрыт: спрятанный
 * пункт выглядит как пропажа возможности, а видимый с замком — как
 * граница прав, о которой можно спросить владельца.
 */

import type { ReactNode } from 'react';
import { ACCESS_LEVEL_LABEL, TIER_ROLES_LABEL, type AccessLevel } from '@ak/shared';

import { IconLock } from '../components/icons.tsx';
import { Panel } from '../components/ui.tsx';

/** Роли Discord, стоящие за уровнями доступа. */
const ROLE_BY_LEVEL: Readonly<Record<AccessLevel, string>> = {
  player: TIER_ROLES_LABEL,
  moderator: 'mentalcore',
  admin: 'morethenmod',
  owner: 'owner',
};

export function LockedPage({
  title,
  level,
  allowedLevels,
}: {
  /** Название раздела, как оно написано в меню. */
  title: string;
  /** Уровень доступа вошедшего — чтобы объяснить, чего не хватает. */
  level: AccessLevel;
  /** Кому раздел открыт. */
  allowedLevels: readonly AccessLevel[];
}): ReactNode {
  return (
    <div className="grid place-items-center py-16">
      <Panel className="animate-in w-full max-w-md p-8 text-center">
        <div
          className="mx-auto grid size-14 place-items-center rounded-2xl"
          style={{ background: 'var(--surface-raised)', color: 'var(--text-muted)' }}
          aria-hidden="true"
        >
          <IconLock size={26} />
        </div>

        <h1 className="mt-5 text-lg font-semibold">Раздел «{title}» закрыт</h1>
        <p className="mt-2 text-sm" style={{ color: 'var(--text-muted)' }}>
          Ваш уровень — {ACCESS_LEVEL_LABEL[level].toLowerCase()} (роль {ROLE_BY_LEVEL[level]}). Раздел открыт для{' '}
          {allowedLevels.map((allowed) => ROLE_BY_LEVEL[allowed]).join(' и ')}.
        </p>
        <p className="mt-3 text-xs" style={{ color: 'var(--text-muted)' }}>
          Доступ выдаётся ролью на сервере Discord — попросите её у владельца сообщества.
        </p>
      </Panel>
    </div>
  );
}
